import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles(theme => ({
  menuButton: {
    backgroundColor: "#fff",
    padding: "0px",
    height: "29px",
    width: "100%",
    [theme.breakpoints.down("xs")]: {
      fontSize: "12px",
      height: "25px",
    },
  },
  dollarSign: {
    backgroundColor: "#fff",
    letterSpacing: "0px",
    padding: "0px",
    height: "29px",
    width: "100%",
    color: "rgba(0, 0, 0, 0.54)",
  },
  menuInput: {
    paddingRight: "5px",
  },
  dollarInput: {
    paddingLeft: "4px",
    paddingRight: "5px",
  },
  mobileLabel: {
    marginTop: "5px",
    fontSize: "12px",
    color: "#9A9A9A",
    textAlign: "center",
  },
}))

export default styles
